module.exports = __webpack_public_path__ + "static/media/logo.17c3c0b0.svg";